const PREFIX = 'users_'
export const LOADING = PREFIX + 'LOADING'
export const UPDATE_ALL = PREFIX + 'UPDATE_ALL'